<template>
  <transition name="ease">
  <div
    class="row product-alternatives"
    v-if="item">
    <div ref="cardWrapper"
            :data-prodid="item.prodID"
            :data-master-style="item.master_style"
            :data-style="item.style"
            :data-name="item.datamann_desc"
            :data-category="item.productType"
            :data-price="item.pricing.min_discount_price"
            data-list="Alternative"
            data-position="0"
            class="hit media">
      <meta itemprop="brand" content="Julianna Rae">
      <meta :content="item.style" itemprop="mpn">
      <div class="image-container">
        <a :href="item.url + item.urlSelector"
            class="href-color-adjust"
            itemprop="url"
            @click="onProductClick" >
          <img ref="mainImage"
              :src="item.listingImageUrl"
              :alt="item.mainImage_alttag"
               width="292"
               height="411"
              itemprop="image">
        </a>
        <div v-if="item.pinterestUrl" class="pinterest pinterest-small">
          <a :href="'https://www.pinterest.com/pin/create/button/?' + item.pinterestUrl" target="_blank" rel="noopener">
            <svg><use xlink:href="#pinterest"/></svg>
          </a>
        </div>
      </div>
      <div class="media-body">
          <div class="oos-message text-primary">
            <p>Yikes! The item you selected is currently sold out.<br>
            We do have a similar style, color and size available.</p>
            <a :href="item.url + item.urlSelector"
               class="href-color-adjust"
               @click="onProductClick">
              Take me there!
            </a>
          </div>
          <div class="product-name">
            <h4 class="hit_name">
              <span itemprop="name" v-html="item.name || item.datamann_desc"/>
            </h4>
            <div v-if="item.alsoPetite" class="also-petite">Also in: Petite</div>
            <div v-if="item.alsoRegular" class="also-petite">Also in: Regular</div>
          </div>
          <div class="product-price">
            <div class="regular-price" v-html="regularPriceLabel(item.pricing)"/>
            <div v-if="item.hasSalePrice" class="sale-price text-primary" v-html="salePriceLabel(item.pricing)"/>
            <star-rating :total-reviews="item.total_reviews" :average-score="item.average_score"/>
          </div>
      </div>
      <div itemprop="offers" itemscope itemtype="http://schema.org/Offer">
        <meta :content="item.pricing.min_discount_price" itemprop="price">
        <meta itemprop="priceCurrency" content="USD">
        <meta itemprop="availability" content="http://schema.org/InStock">
        <meta itemprop="itemCondition" content="http://schema.org/NewCondition">
      </div>
    </div>
  </div>
  </transition>
</template>

<style scoped>
.product-alternatives {
  border: 2px solid #990033;
  border-radius: 5px;
  margin: 10px 0 0 0;
}
.hit {
  padding: 5px;
  position: relative;
  min-height: 200px;
}
.oos-message {
  text-align: center;
  margin-top: 10px;
}
.product-name {
  position: absolute;
  bottom: 5px;
}
.product-price {
  position: absolute;
  bottom: 5px;
  right: 10px;
  text-align: right;
}
.hit_name {
  margin-top: 0;
  margin-bottom: 5px;
}
.sale-price {
  margin-left: 15px;
}
.image-container {
  position: relative;
  float: left;
  width: 20%;
}
.image-container a > img {
  display: block;
  max-width: 100%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}
.media-body {
  padding-left: 10px;
}
.hit a {
  color: black;
}
</style>

<script>
import axios from 'axios'
import { jrNotifyEx } from '../../bootstrap'
import StarRating from './StarRating'
import { handleProductClick } from '../../module/util'
import { CurrencyMixin } from "../../mixins/CurrencyMixin"

export default {
    components: {
        'star-rating': StarRating
    },

    mixins: [CurrencyMixin],

    props: {
        masterStyle: {
            type: String,
            default: null
        }
    },

    data () {
        return {
            sizechartid: null,
            color: null,
            size: null,
            item: null
        }
    },

    computed: {
        queryUrl () {
            if (this.sizechartid && this.color && this.size) {
                return '/alternatives/' +
                    this.masterStyle + '/' +
                    this.sizechartid + '/' +
                    this.color + '/' +
                    this.size.replace(/\//g, '_')
            }

            return null
        }
    },

    methods: {
        async fetchAlternatives () {
            this.item = null
            var url = this.queryUrl
            if (url) {
              try {
                const response = await axios.get(url)
                if (response.data.data && response.data.data.length) {
                    this.item = this.mappedItem(response.data.data[0])
                }
              } catch (e) {
                jrNotifyEx(e)
              }
            }
        },
        setInStock () {
            this.item = null
        },
        setOutOfStock (sizechartid, color, size) {
            this.sizechartid = sizechartid
            this.color = color
            this.size = size
            this.fetchAlternatives()
        },
        imageUrl (item, size, id) {
            return item.baseImageUrl + '/' + size + '/' + id + '.jpg'
        },
        mappedItem (item) {
            item.master_style = item.master_style || item.style
            item.urlSelector += '&size=' + this.size
            return item
        },
        onProductClick () {
            handleProductClick()
        },
    }
}
</script>
